var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"marketing-sms-form-senders-list-item"},[_c('td',{staticClass:"marketing-sms-form-senders-list-item-checkbox"},[_c('v-checkbox',{attrs:{"input-value":_vm.isSelected},on:{"click":_vm.checkIfSetSenderType}})],1),_c('td',{staticClass:"marketing-sms-form-senders-list-item-key"},[_vm._v("\n    "+_vm._s(_vm.item.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }